// Per-environment settings (DEVOPS-326). Deploys write public/env.js as
// window.__XO_ENV__ = {...}, so one build serves every environment; local `npm start` falls back
// to REACT_APP_* from .env (copied from env/env.<env>).
const runtime = (typeof window !== 'undefined' && window.__XO_ENV__) || {};

export const API_HOST = runtime.API_HOST || process.env.REACT_APP_API_HOST;
